export const generateUid = (length: number = 10): string => {
  const uidArray = Array(length)
    .fill(0)
    .map(() => Math.floor(65 + Math.random() * 26));
  // console.log("uid", uidArray, String.fromCharCode(...uidArray));

  return String.fromCharCode(...uidArray);
};
